// 调试API
import request from '@/utils/request/index';

// eyes submit
export function getConfirmDelegator () {
    return request({
        url: '/delegator-infos/confirmDelegator ',
        method: 'GET'
    });
}
